import { getMenuReadPermission } from './menuPermissionMap'
import { isPermanentlyHiddenRoute } from '../../../../../app/shared/navigation/permanentlyHiddenMenus'

const PUBLIC_AUTHENTICATED_ROUTES = new Set(['/dashboard'])

export const isExplicitPublicSidebarRoute = (route?: string): boolean => {
  const normalized = String(route || '').trim().replace(/\/+$/, '').toLowerCase()
  return PUBLIC_AUTHENTICATED_ROUTES.has(normalized)
}

export const filterMenuByPermissions = (
  nodes: any[] | undefined,
  canRead: (permissionCode: string) => boolean
): any[] => {
  if (!Array.isArray(nodes)) return []

  const hasPermission = (permissionCode: string) => {
    const normalized = String(permissionCode || '').trim()
    if (!normalized) return false
    if (normalized.includes('|')) {
      return normalized.split('|').some((candidate) => canRead(candidate.trim()))
    }
    return canRead(normalized)
  }

  return nodes
    .map((node) => {
      const hasSubmenu = Array.isArray(node?.submenu)
      const mappedChildren = hasSubmenu ? filterMenuByPermissions(node.submenu, canRead) : undefined
      const route = String(node?.route || '').trim()
      if (isPermanentlyHiddenRoute(route)) return null
      const hasRoute = Boolean(route)
      const requiredPermission = getMenuReadPermission(route)
      const isPublicRoute = isExplicitPublicSidebarRoute(route)

      if (hasSubmenu) {
        if (mappedChildren && mappedChildren.length > 0) {
          return {
            ...node,
            submenu: mappedChildren,
          }
        }
        if (!hasRoute) return null
        if (isPublicRoute) return { ...node, submenu: [] }
        if (!requiredPermission) return null
        return hasPermission(requiredPermission) ? { ...node, submenu: [] } : null
      }

      if (!hasRoute) return null
      if (isPublicRoute) return node
      if (!requiredPermission) return null
      return hasPermission(requiredPermission) ? node : null
    })
    .filter(Boolean) as any[]
}
